import Address from "components/shared/address";
import { formatDateTimezone, getShortAddress } from "helpers/bidpoint";
import { dateTimeToView } from "helpers/date";
import React from "react";

const AddressWithTime = ({ point, showFullAddress = false }) => {
    const time = dateTimeToView(point.planEnterDate);
    const utcTimezone = formatDateTimezone(point);
    const address = getShortAddress(point.geozone, showFullAddress);
    return (
        <>
            <span className="clearfix">
                <Address address={address} />
            </span>
            <small className="text-muted">
                {time} {utcTimezone}
            </small>
        </>
    );
};

export default AddressWithTime;
